import { ColumnDef } from '@tanstack/react-table';
import { Pencil } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { ContainerType } from 'src/trpc';
interface ContainerTypeWithActions extends Omit<ContainerType, 'pricePerDay' | 'preAuthAmount'> {
  pricePerDay: number;
  preAuthAmount: number;
  displayPricePerDay: string;
  displayPreAuthAmount: string;
  onEdit: (containerType: ContainerType) => void;
}

export const ContainerTypeColumns: ColumnDef<ContainerTypeWithActions>[] = [
  {
    accessorKey: 'name',
    header: 'Name',
  },
  {
    accessorKey: 'size',
    header: 'Size',
  },
  {
    accessorKey: 'maxWeight',
    header: 'Max Weight (lbs)',
    cell: ({ row }) => {
      const formattedWeight = row.original.maxWeight.toFixed(2);
      return formattedWeight.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
  },
  {
    accessorKey: 'pricePerDay',
    header: 'Price Per Day',
    cell: ({ row }) => row.original.displayPricePerDay,
  },
  {
    accessorKey: 'preAuthAmount',
    header: 'Pre-Auth Amount',
    cell: ({ row }) => row.original.displayPreAuthAmount,
  },
  {
    accessorKey: 'archived',
    header: 'Archived',
    cell: ({ row }) => (row.original.archived ? 'Yes' : 'No'),
  },
  {
    id: 'actions',
    header: 'Edit',
    cell: ({ row }) => {
      // Create a ContainerType object from the row data for the onEdit callback
      const containerType: ContainerType = {
        ...row.original,
        pricePerDay: row.original.pricePerDay,
        preAuthAmount: row.original.preAuthAmount,
      };
      return (
        <Button
          variant="ghost"
          onClick={(e) => {
            e.stopPropagation();
            row.original.onEdit(containerType);
          }}
        >
          <Pencil className="h-4 w-4" />
        </Button>
      );
    },
  },
];
